export function formatPercentage(value: number | null): string {
  if (!value || value === null) {
    return "N/A";
  }

  return `${value.toFixed(0)}%`;
}
